export default __webpack_public_path__ + "static/media/upgrade.17f17a54.jpg";